import type { UpdateSettingsAddReferenceKpisInput } from "../domain/settings";
import { fetchQuery } from "../shared/http-client";
import { type Settings, formatToSettings } from "./settings.formatter";

export async function fetchSettingsAPI(): Promise<Settings> {
  const { data } = await fetchQuery("settings");
  return formatToSettings(data);
}

export async function updateSettingsDefaultReferenceAPI(
  referenceId: number,
  tableId: number,
): Promise<void> {
  await fetchQuery("settings/default-reference", {
    method: "PUT",
    body: JSON.stringify({
      default_reference_id: referenceId,
      default_table_id: tableId,
    }),
  });
}

export async function updateSettingsAddReferenceKpisAPI({
  kpis,
  histogramKpi,
  referenceId,
}: UpdateSettingsAddReferenceKpisInput): Promise<void> {
  await fetchQuery("settings/reference-kpis", {
    method: "PUT",
    body: JSON.stringify({
      reference_id: referenceId,
      kpis: kpis.map((k) => ({
        table_id: k.tableId,
        porperty: k.property,
        value: k.value,
        name: k.name,
      })),
      histogram_kpi: {
        table_id: histogramKpi.tableId,
        name: histogramKpi.name,
        porperty: histogramKpi.property,
      },
    }),
  });
}
